import { render, staticRenderFns } from "./MyprofileAccordian.vue?vue&type=template&id=1e460960&"
import script from "./MyprofileAccordian.vue?vue&type=script&lang=ts&"
export * from "./MyprofileAccordian.vue?vue&type=script&lang=ts&"
import style0 from "./MyprofileAccordian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports